import { useLocation } from 'react-router-dom';

import { GROUP_LABEL, matchNav } from './nav-config';

/**
 * 設計系統上方導覽列（對應 docs/cms-screens 之 Component/TopBar）。
 *
 * 標題依當前路由由 matchNav 決定；label 去除括號內的 AC 註記作為大標題。
 * 搜尋框 / 通知 / 使用者於地基階段為靜態視覺，功能待後續各頁接入。
 */
export function TopBar(): JSX.Element {
  const location = useLocation();
  const nav = matchNav(location.pathname);
  const title = (nav?.label ?? 'Boat CMS').replace(/（.*）/, '').trim();
  const crumb = nav ? GROUP_LABEL[nav.group] : 'Boat Ticket CMS';

  return (
    <header className="app-topbar">
      <div className="app-topbar__heading">
        <div className="app-topbar__crumb">{crumb}</div>
        <div className="app-topbar__title">{title}</div>
      </div>
      <input
        className="app-topbar__search"
        type="search"
        placeholder="搜尋訂單 / 商品 / 裝置…"
        aria-label="搜尋"
      />
      <button className="app-topbar__icon-btn" type="button" aria-label="通知">
        🔔
      </button>
      <div className="app-topbar__user">
        <div className="app-topbar__avatar">管</div>
        <span>管理員</span>
      </div>
    </header>
  );
}
